import defaultImg from "../assets/default.webp";
import mediaUrl from "../utils/mediaUrl";

const ProductImage = ({ url, alt, loading, className, onClick }) => {
  return (
    <img
      src={url ? mediaUrl(url) : defaultImg}
      alt={alt}
      loading={loading}
      className={className}
      onClick={onClick}
      onError={(e) => {
        e.target.src = defaultImg;
        e.target.style.objectFit = "contain";
      }}
    />
  );
};

export default ProductImage;
